<template>

    <b-modal id="my-quizzes-save-empty-fields-modal" class="modal-save-empty-fields" size="sm" centered hide-header hide-footer>

        <div class="close-btn" @click="close"></div>

        <div class="px-1 py-3">
            <p class="mb-3">{{ t.__('Czy napewno chcesz zapisać pytania z pustymi polami?') }}</p>
            <div class="row">
                <div class="col-9">
                    <div class="row">
                        <div class="col-6">
                            <b-button variant="secondary" block @click="close">{{ t.__('Jeszcze nie') }}</b-button>
                        </div>
                        <div class="col-6">
                            <b-button variant="success" block @click="submit">{{ t.__('Tak') }}</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </b-modal>

</template>

<script>

export default {

    name: 'MyQuizzesSaveEmptyFieldsModal',

    data() {
        return {
            eventHub: window.eventHub,
            processing: false
        }
    },

    beforeMount() {

        this.eventHub.$on('my-quizzes-edit-with-empty-fields-confirm', () => {
            this.$bvModal.show('my-quizzes-save-empty-fields-modal')
        });

        this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
            if (modalId === 'my-quizzes-save-empty-fields-modal') {
                this.processing = false;
            }
        });

    },

    methods:  {

        close() {
            this.$bvModal.hide('my-quizzes-save-empty-fields-modal');
        },

        submit() {
            this.eventHub.$emit('my-quizzes-edit-with-empty-fields-confirmed');
            this.close();
        }

    }

}

</script>

<style scoped>

</style>
